import moment from 'moment';

const rawValueExtractor = (value) => value;

export const cellDataFormatter = {
  0: rawValueExtractor,
  1: rawValueExtractor,
  2: rawValueExtractor,
  3: rawValueExtractor,
  4: rawValueExtractor,
  5: rawValueExtractor,
  6: rawValueExtractor,
  7: rawValueExtractor,
  8: rawValueExtractor,
  9: rawValueExtractor,
  10: (text) => (text ? moment.unix(text).format('DD/MM/YYYY') : '--/--/--'),
  100: (value, column) =>
    value
      ? column.columnCOntentType.multiselect
        ? `(${(value || []).length}) items selected`
        : ((column.selection || []).find((item) => item.id === value) || {})
            .title
      : '-',
};
